<template lang="html">
  <b-container fluid>
    <div class="mt-5">
      <h3 class="pink-text">Be one of the first to try out HappyG (and gain exclusive early-bird benefits in the process) - your feedback will mean the world to us!
      </h3>
      <br>
      <p class="blue-text">Fill in your email below and we'll notify you as soon as we're ready to ship the first kits</p>
    </div>
    <div class="">
      <MailchimpForm />
      <b-row>
        <p class="ml-3 mt-4 small-text"> <em> *Fret not! We would never give away your email or spam your inbox - we hate spamming as much as you do! </em></p>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import MailchimpForm from './MailchimpForm'
export default {
  components: {
    MailchimpForm,
  }
}
</script>

<style lang="css" scoped>
</style>
